var render = function render(_c,_vm){return _c('h4',{staticClass:"my-2"},[_vm._v(_vm._s(_vm.props.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }